/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import CustomersTable from '../modules/AnaVezne/Content/CustomersTable'
import FilterCard from '../modules/AnaVezne/Content/FilterCard'
import TableButtons from '../modules/AnaVezne/Content/TableButtons'
import './ana-vezne.css'
import VezneModalCard from '../modules/AnaVezne/Modal/VezneModalCard'
import { RootState} from '../../setup'
import {useDispatch, useSelector} from 'react-redux'
import { setAllCustomers, setFilteredCustomers} from '../../setup/slices/AnavezneSlice'
import { changeModalVisibility } from '../../setup/slices/ModalSlice'
import { AnaVezneStoreCall } from '../modules/AnaVezne/apis/ApiCall'

const AnaVezne: React.FC = () => {

  const [customerInfo, setCustomerInfo] = useState<any>()
  const [stores, setStores] = useState<{Detail: [], Status: string}>({Detail: [], Status: 'LOADING'})
  const [customers, setCustomers] = useState<{Detail: [], Status: string}>({Detail: [], Status: 'LOADING'})
  const [currentStore, setCurrentStore] = useState<{AnavezneKodu: string, AnavezneAdi: string}>({AnavezneAdi: '', AnavezneKodu:''})
  const [isLoading, setIsLoading] = useState<boolean>()

  const dispatch = useDispatch()

  const isVisible = useSelector((state: RootState) => state.isVisible.isVisible) 



  useEffect(() => {
    dispatch(changeModalVisibility(false))
    AnaVezneStoreCall(setStores)
  }, [])

  useEffect(() => {
    if(customers.Status === "SUCCESS") {
      dispatch(setAllCustomers(customers))
    }
  }, [customers])


    return( <>
      {isVisible ? <VezneModalCard customer={customerInfo} stores={stores} setCustomers={setCustomers} setIsLoading={setIsLoading}/> : null}

      <div className='card card-xxl-stretch mb-5 mb-xl-8'>
        <FilterCard stores={stores} setCustomers={setCustomers} setCurrentStore={setCurrentStore} setIsLoading={setIsLoading}/>

        {/* begin::Body */}
        <div className='card-body py-3 px-0'>
          <CustomersTable setCustomerInfo={setCustomerInfo} customers={customers} setIsLoading={setIsLoading} isLoading={isLoading}/>
        </div>
        <TableButtons currentStore={currentStore} />
        {/* begin::Body */}
      </div>
    </>
  )
}

export {AnaVezne}
